import { HttpService } from '@/shared/api/services/HttpService';
import { buildUrlForServiceName } from '@/connection/url-retriever';
import conf from '@/shared/config/useConfig';
import type { Projekt } from '@/types/Projekt';
import type { FilterOptionen } from '@/components/datatable/types/FilterObject.ts';
import type {
  ProjektFilter,
  ProjektFilterResponse,
} from '@/connection/filter-helper/filter-helper-projekte.ts';

export class SharedProjektService extends HttpService {
  protected projektServiceBaseUrl = `${buildUrlForServiceName(
    conf.projektserviceName,
  )}/buergschaftservice/api/private/v1`;

  async holeProjektZuBuergschaft(buergschaftId: number): Promise<Projekt> {
    return this.httpClient.get(
      `${this.projektServiceBaseUrl}/projekte/buergschaften/${buergschaftId}`,
    );
  }

  async holeFilterOptionenProjekte(): Promise<FilterOptionen> {
    return this.httpClient.get(`${this.projektServiceBaseUrl}/projekte/filteroptionen`);
  }

  async holeProjekteMitPaginierungUndFilterung(
    seite: number,
    seitengroesse: number,
    property: string,
    sortierArt: string,
    projektFilter: ProjektFilter,
  ): Promise<ProjektFilterResponse> {
    return this.httpClient.post(`${this.projektServiceBaseUrl}/projekte/filterung`, {
      params: { page: seite, size: seitengroesse, sort: `${property},${sortierArt}` },
      data: projektFilter,
    });
  }

  async istProjektMitFremdIdBereitsVorhanden(fremdId: string): Promise<boolean> {
    return this.httpClient.get(`${this.projektServiceBaseUrl}/ist-vorhanden`, {
      params: { fremdId },
    });
  }

  async istProjektMitProjektnameBereitsVorhanden(projektname: string): Promise<boolean> {
    return this.httpClient.get(`${this.projektServiceBaseUrl}/ist-vorhanden`, {
      params: { projektname },
    });
  }
}
